import Map from 'eemovel-map-library/src/data/google-maps/map';
import MarkerClusterer from '@googlemaps/markerclustererplus';

import ClusterIcon from '../../../../assets/img/Ellipse_39.svg';
import Icon from '../../../../assets/img/CIRCLE-red-border.svg';

import { updateClusters, updateMarkers } from '../../redux/dashboardActions';
import { infoWindowRealtyOffersPrimary } from './offersPrimary.infowindow';

import {
  generateBuildingDetailsModal,
  generateInfoWindow,
} from './offersPrimary.controller';

export const generateMarkersOnMap = (geometry, type) => {
  return (dispatch) => {
    const google = window.google;

    const mappedCoordinates = geometry?.map((geometry) => ({
      rawCoordinates: {
        lat: geometry?.location_point[0],
        long: geometry?.location_point[1],
      },
      coordinates: new google.maps.LatLng(
        geometry?.location_point[0],
        geometry?.location_point[1]
      ),
      rgi: geometry?.rgi,
    }));

    const markers = mappedCoordinates?.map((location) => {
      const marker = new google.maps.Marker({
        position: location?.coordinates,
        map: Map.map,
        icon: Icon,
      });

      if (type === 'primary') {
        marker.addListener('click', function () {
          dispatch(
            generateInfoWindow(location?.rgi, marker, location?.rawCoordinates)
          );
        });
      }

      return marker;
    });

    const clusterOptions = {
      styles: [
        {
          url: ClusterIcon,
          height: 24,
          width: 24,
          textColor: '#FFF',
          fontWeight: 400,
          textSize: 14,
          anchorText: [5, 0],
        },
      ],
    };

    const map = Map.map;

    const markerCluster = new MarkerClusterer(map, markers, clusterOptions);
    dispatch(updateMarkers(markers));
    dispatch(updateClusters(markerCluster));
  };
};

export const createOpenInfoWindow = ({ data, marker, rgi }) => {
  const google = window.google;
  const infowindow = new google.maps.InfoWindow({
    content: infoWindowRealtyOffersPrimary({ payload: data, rgi }),
    maxWidth: '800px',
    zIndex: 5,
  });
  infowindow.open(Map.map, marker);
  return infowindow;
};

export const addIWListener = (payload) => {
  return (dispatch) => {
    const map = document.getElementById('mapsToRender');

    const listener = (e) => {
      const split = e?.srcElement?.id?.split(',');
      if (split[0] === 'IWButton' && split[1] === payload?.rgi) {
        dispatch(generateBuildingDetailsModal(payload));
      }
    };
    map.removeEventListener('click', listener);
    map.addEventListener('click', listener);
  };
};
